/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/jsx-wrap-multilines */
import React, { ChangeEvent, FunctionComponent, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Button,
  Checkbox,
  DatePicker,
  InputAutosuggest,
  Layout,
  Select as SelectBR,
  Spinner,
} from '@vwfs-bronson/bronson-react';
import { useFormikContext } from 'formik';
import { TFunction } from 'i18next';
import get from 'lodash/get';
import moment from 'moment';
import { FormField } from '../../../components/FormField/FormField';
import {
  charsReplacementMap1,
  getMobilePhoneLengthMaskForCountry,
  MaskedTextFormField,
  masks,
} from '../../../components/FormFields/MaskedTextFormField';
import { NumericFormField } from '../../../components/FormFields/NumericFormField';
import { SelectFormField } from '../../../components/FormFields/SelectFormField';
import { StaticTextFormField } from '../../../components/FormFields/StaticTextFormField';
import { TextFormField } from '../../../components/FormFields/TextFormField';
import {
  contractTypeOptions,
  genderOptions,
  housingSituationOptions,
  isExistingClient,
  kindOfCompany,
  LVDLDropdown,
  maritalStatusOptions,
  milesCoCustomerRelationOptions,
  professionOptions,
  telephoneCountryCodesOptions,
  yesOrNot,
} from '../../../resources/base/models';
import {
  countryCodesOptions,
  frenchTerritoriesOptions,
  translateCountryCodeToCountry,
} from '../../../resources/base/models/country';
import { BooleanEnum, CustomerDetailsSection, EnumCountryCode } from '../../../resources/base/models/enums';
import { CitiesAndZipCodesSuggestion } from '../../../services/api/address/localitiesAndZipCodes';
import { validateIBAN } from '../../../services/api/iban/validIBAN';
import { normalizeDate } from '../../../services/common/format';
import { getMaxBirthDate, getMinBirthDate } from '../../../services/common/validation';
import { AddressDataFormType, ContactDataFormType } from '../Step4/privateCustomerDetailsForms/initialValues';
import { InvolvementInCompanies } from '../Step4/utils';
import { formatEmail } from './emailFormatter';
import { formatCityNameLettersAndSpaceOnly, formatCityNameWithProperCasing } from './formatCityString';
import { setBicValueFromIban } from './validateIbanUtil';

export interface Props {
  t: TFunction;
  value?: any;
  setFieldValue?: any;
  handleChange?(e: ChangeEvent<any>): void;
  setIsLoading?: any;
  customerType?: any;
  values?: any;
  index?: number;
  cocontractor?: boolean;
  infoText?: string;
  fieldValue?: boolean;
  setCocontractor?: any;
  customerHasCompany?: boolean;
  setCustomerHasCompany?: any;
  checkOut?: boolean;
  formData?: any;
  name?: any;
  label?: any;
  notRequired?: boolean;
  setCoContractorScreenActive?: any;
  visiblePopup?: boolean;
  setVisiblePopup?: any;
  coContractorScreenActive?: boolean;
  errors?: any;
  contractorFromProspect?: any;
  sct?: any;
  tlsCheckStatus?: any;
  legalEntityValue?: any;
  contractAssigner?: any;
  currentPage?: any;
  ceoFromFrance?: any;
  professionCocontractor?: any;
  profession?: any;
  financialProduct?: any;
  isLoading?: boolean;
  chosenProductType?: any;
  contactSubmittedPC?: any;
  setContactSubmittedPC?: any;
  addressSubmittedPC?: any;
  setAddressSubmittedPC?: any;
  paymentSubmittedPC?: any;
  setPaymentSubmittedPC?: any;
  contactSubmittedCC?: any;
  setContactSubmittedCC?: any;
  addressSubmittedCC?: any;
  setAddressSubmittedCC?: any;
  financialSubmittedPC?: any;
  setFinancialSubmittedPC?: any;
  paymentSubmittedCC?: any;
  setPaymentSubmittedCC?: any;
  companySubmittedPC?: any;
  setCompanySubmittedPC?: any;
  companySubmittedCC?: any;
  setCompanySubmittedCC?: any;
  submittedSections?: CustomerDetailsSection[];
  setSubmittedSections?: any;
  hybridJourney?: boolean;
  disabled?: boolean;
  isSectionLoading?: boolean;
  initialSection?: CustomerDetailsSection | '';
}

export const Gender: FunctionComponent<Props> = ({ t, disabled }) => {
  return (
    <FormField
      required
      type="select"
      name="gender"
      labelText={t('step2:gender:label')}
      render={(fieldProps) => (
        <SelectBR {...fieldProps} disabled={disabled}>
          {genderOptions?.map(({ label, value }) => (
            <SelectBR.Item key={`${label}`} value={`${value}`}>
              {label}
            </SelectBR.Item>
          ))}
        </SelectBR>
      )}
    />
  );
};

export const DropdownForLVDL: FunctionComponent<Props> = ({ cocontractor }) => {
  return (
    <FormField
      required
      type="select"
      name={cocontractor ? 'applicationFor' : 'applicationFor'}
      labelText=""
      render={(fieldProps) => (
        <SelectBR {...fieldProps}>
          <SelectBR.Item selected disabled hidden value="">
            Employé
          </SelectBR.Item>
          {LVDLDropdown?.map(({ label, value }) => (
            <SelectBR.Item key={`${label}`} value={`${value}`}>
              {label}
            </SelectBR.Item>
          ))}
        </SelectBR>
      )}
    />
  );
};

export const FirstName: FunctionComponent<Props> = ({ cocontractor, disabled }) => (
  <MaskedTextFormField
    mask={masks.nameMask}
    fieldName={cocontractor ? 'firstNameCocontractor' : 'firstName'}
    labelTranslationKey="step2:firstName:label"
    overwrite
    onAcceptCharsReplacementMap={charsReplacementMap1}
    isDisabled={disabled}
  />
);

export const LastName: FunctionComponent<Props> = ({ cocontractor, disabled }) => (
  <MaskedTextFormField
    mask={masks.nameMask}
    fieldName={cocontractor ? 'lastNameCocontractor' : 'lastName'}
    labelTranslationKey="step2:lastName:label"
    overwrite
    onAcceptCharsReplacementMap={charsReplacementMap1}
    isDisabled={disabled}
  />
);

export const BirthName: FunctionComponent<Props> = ({ cocontractor, disabled }) => (
  <MaskedTextFormField
    mask={masks.nameMask}
    fieldName={cocontractor ? 'birthNameCocontractor' : 'birthName'}
    labelTranslationKey="step2:birthName:label"
    overwrite
    onAcceptCharsReplacementMap={charsReplacementMap1}
    isDisabled={disabled}
  />
);

interface DateOfBirthProps {
  labelText: string;
  setFieldValue: (...args: any[]) => any;
  values: any;
  cocontractor?: boolean;
  infoText: string;
  disabled?: boolean;
}

export const DateOfBirth: FunctionComponent<DateOfBirthProps> = ({
  labelText,
  setFieldValue,
  values,
  cocontractor,
  infoText,
  disabled,
}) => {
  const { setFieldValue: setFieldValueInternal } = useFormikContext<any>();
  return (
    <FormField
      name={cocontractor ? 'dateOfBirthCocontractor' : 'dateOfBirth'}
      type="other"
      labelText={labelText}
      required
      infoText={infoText}
      render={(fieldProps) => (
        <DatePicker
          {...fieldProps}
          name={cocontractor ? 'dateOfBirthCocontractor' : 'dateOfBirth'}
          maxDate={getMaxBirthDate()}
          minDate={getMinBirthDate()}
          dateFormat="d/m/Y"
          locale="fr"
          placeholder="j/m/a"
          mode="single"
          disabled={disabled}
          flatpickrOptions={{
            onClose: (e: any) => {
              const date = normalizeDate(e);
              try {
                if (date === 'Invalid date') {
                  throw new Error('');
                }
                setFieldValue(cocontractor ? 'dateOfBirthCocontractor' : 'dateOfBirth', normalizeDate(e));
                setFieldValueInternal(cocontractor ? 'dateOfBirthCocontractor' : 'dateOfBirth', normalizeDate(e));
              } catch (error) {
                setFieldValue(cocontractor ? 'dateOfBirthCocontractor' : 'dateOfBirth', '');
                setFieldValueInternal(cocontractor ? 'dateOfBirthCocontractor' : 'dateOfBirth', '');
              }
            },
          }}
          value={get(values, cocontractor ? 'dateOfBirthCocontractor' : 'dateOfBirth', '')}
          onChange={(e) => {
            setFieldValueInternal(cocontractor ? 'dateOfBirthCocontractor' : 'dateOfBirth', normalizeDate(e));
            setFieldValue(cocontractor ? 'dateOfBirthCocontractor' : 'dateOfBirth', e);
          }}
          onBlur={(e) => {
            setFieldValue(cocontractor ? 'dateOfBirthCocontractor' : 'dateOfBirth', e);
            setFieldValueInternal(cocontractor ? 'dateOfBirthCocontractor' : 'dateOfBirth', normalizeDate(e));
          }}
        />
      )}
    />
  );
};

export const Profession: FunctionComponent<Props> = ({ t, cocontractor, disabled }) => {
  return (
    <FormField
      required
      type="select"
      name={cocontractor ? 'professionCocontractor' : 'profession'}
      labelText={t('step2:profession:label')}
      render={(fieldProps) => (
        <SelectBR {...fieldProps} disabled={disabled}>
          {professionOptions?.map(({ label, value }) => (
            <SelectBR.Item key={`${label}`} value={`${value}`}>
              {label}
            </SelectBR.Item>
          ))}
        </SelectBR>
      )}
    />
  );
};

export const CustomerRelations: FunctionComponent<Props> = ({ t }) => {
  return (
    <FormField
      required
      type="select"
      name="customerRelations"
      labelText={t('step2:customerRelations:label')}
      render={(fieldProps) => (
        <SelectBR {...fieldProps}>
          {milesCoCustomerRelationOptions?.map(({ label, value }) => (
            <SelectBR.Item key={`${label}`} value={`${value}`}>
              {label}
            </SelectBR.Item>
          ))}
        </SelectBR>
      )}
    />
  );
};

export const Email: FunctionComponent<Props> = () => {
  const { setFieldValue } = useFormikContext<ContactDataFormType>();
  return (
    <TextFormField
      fieldName="email"
      labelTranslationKey="step2:email:label"
      onChange={(event) => {
        setFieldValue('email', formatEmail(event.target.value));
      }}
    />
  );
};

export const TelephonePhone: FunctionComponent<Props> = ({ cocontractor }) => {
  const name = cocontractor ? 'telephonePhoneCocontractor' : 'telephonePhone';
  return (
    <MaskedTextFormField
      fieldName={name}
      labelTranslationKey="step2:telephonePhone:label"
      mask={masks.phonePrefixContactMask}
      placeholder="+33 ###############"
      optional
    />
  );
};

export const MobilePhone: FunctionComponent<Props> = ({ cocontractor }) => {
  const { values } = useFormikContext<ContactDataFormType>();
  const name = cocontractor ? 'mobilePhoneCocontractor' : 'mobilePhone';
  const mask = getMobilePhoneLengthMaskForCountry(values.mobilePhoneCountryCode || '+33');
  const isFrenchMobilePhone = values.mobilePhoneCountryCode === '+33';

  return (
    <MaskedTextFormField
      fieldName={name}
      labelTranslationKey="step2:mobilePhone:label"
      mask={mask}
      placeholder="##########"
      infoTextTranslationKey={isFrenchMobilePhone ? 'step2:mobilePhone:infoText' : undefined}
    />
  );
};

export const HouseNumberAndStreet: FunctionComponent<Props & { onManualAddressInput(): void }> = ({
  handleChange,
  onManualAddressInput,
  name,
}) => (
  <TextFormField
    fieldName={name ?? 'houseNumber'}
    labelTranslationKey="step4:houseNumber:label"
    onChange={(e) => {
      handleChange!(e as ChangeEvent<any>);
      onManualAddressInput();
    }}
  />
);

export const Street: FunctionComponent<Props & { onManualAddressInput(): void }> = ({
  name,
  handleChange,
  onManualAddressInput,
}) => (
  <TextFormField
    fieldName={name ?? 'street'}
    labelTranslationKey="step4:street:label"
    optional
    onChange={(e) => {
      handleChange!(e as ChangeEvent<any>);
      onManualAddressInput();
    }}
  />
);

export const ZipCode: FunctionComponent<Props & { onManualAddressInput(): void }> = ({
  name,
  onManualAddressInput,
}) => {
  return (
    <MaskedTextFormField
      fieldName={name}
      labelTranslationKey="step4:zipCode:label"
      mask={masks.zipCodeMask}
      onBlurCapture={() => {
        onManualAddressInput();
      }}
    />
  );
};

export const City: FunctionComponent<Props & { onManualAddressInput(): void }> = ({
  handleChange,
  onManualAddressInput,
  name,
}) => (
  <TextFormField
    fieldName={name ?? 'city'}
    labelTranslationKey="step4:city:label"
    onChange={(e) => {
      handleChange!(e as ChangeEvent<any>);
      onManualAddressInput();
    }}
  />
);

export const CountryCodeMobilePhone: FunctionComponent<Props> = ({ t, cocontractor, name }) => {
  name = name || (cocontractor ? 'mobilePhoneCountryCodeCocontractor' : 'mobilePhoneCountryCode');
  return (
    <FormField
      className="u-text-left"
      name={name}
      type="select"
      labelText={t('sf-sac:continueLater:form:customerPhoneCountryCode')}
      required
      render={(fieldProps) => (
        <SelectBR {...fieldProps}>
          {telephoneCountryCodesOptions?.map(({ label, value }) => (
            <SelectBR.Item key={`${label}`} value={`${value}`}>
              {label}
            </SelectBR.Item>
          ))}
        </SelectBR>
      )}
    />
  );
};

export const CountryCode: FunctionComponent = () => {
  const { values } = useFormikContext<AddressDataFormType>();
  return (
    <StaticTextFormField
      fieldName="countryCode"
      labelTranslationKey="step4:countryCode:label"
      displayValue={translateCountryCodeToCountry(values.countryCode)}
    />
  );
};

export const BankAccountOwner: FunctionComponent<Props> = () => (
  <TextFormField fieldName="bankAccountOwner" labelTranslationKey="step4:bankAccountOwner:label" />
);

export const OpeningDate: FunctionComponent<Props> = ({ label, values, setFieldValue }) => {
  const { setFieldValue: setFieldValueInternal } = useFormikContext<any>();
  return (
    <FormField
      name="openingDate"
      type="other"
      labelText={label}
      required
      render={(fieldProps) => (
        <DatePicker
          {...fieldProps}
          name="openingDate"
          maxDate={moment().toDate()}
          dateFormat="d/m/Y"
          locale="fr"
          placeholder="d/m/Y"
          mode="single"
          flatpickrOptions={{
            onClose: (e: any) => {
              const date = normalizeDate(e);
              try {
                if (date === 'Invalid date') {
                  throw new Error('');
                }
                setFieldValue('openingDate', normalizeDate(date));
                setFieldValueInternal('openingDate', normalizeDate(date));
              } catch (error) {
                setFieldValue('');
                setFieldValueInternal('openingDate', '');
              }
            },
          }}
          value={get(values, 'openingDate', '')}
          onChange={(e) => {
            const date = normalizeDate(e);
            setFieldValue('openingDate', date);
            setFieldValueInternal('openingDate', normalizeDate(date));
          }}
          onBlur={(e) => {
            const date = normalizeDate(e);
            setFieldValue('openingDate', date);
            setFieldValueInternal('openingDate', normalizeDate(date));
          }}
        />
      )}
    />
  );
};

export const Iban: FunctionComponent<Props> = ({ setFieldValue }) => {
  const handleOnBlur = async (e: React.FocusEvent<HTMLInputElement>) => {
    await setBicValueFromIban(e.target.value, setFieldValue, validateIBAN);
  };

  return (
    <MaskedTextFormField
      mask={masks.ibanMask}
      fieldName="iban"
      labelTranslationKey="step4:iban:label"
      onBlurCapture={handleOnBlur}
      overwrite
      removeWhitespace
    />
  );
};

export const Bic: FunctionComponent<Props> = ({ isLoading }) => {
  const { values } = useFormikContext<{ bic: string }>();
  const isDisabled = !!values.bic || isLoading;
  return (
    <TextFormField
      isDisabled={isDisabled}
      fieldName="bic"
      labelTranslationKey="step4:bic:label"
      addonSpinner={isLoading && <Spinner center small />}
    />
  );
};

export const CustomerType: FunctionComponent<Props> = () => {
  return (
    <FormField
      required
      type="select"
      name="isExistingClient"
      render={(fieldProps) => (
        <SelectBR {...fieldProps}>
          {isExistingClient?.map(({ label, value }) => (
            <SelectBR.Item key={`${label}`} value={value}>
              {label}
            </SelectBR.Item>
          ))}
        </SelectBR>
      )}
    />
  );
};

export const PreviousContractNumber: FunctionComponent<Props> = () => (
  <TextFormField fieldName="previousContractNumber" labelTranslationKey="step2:previousContractNumber:label" />
);

export const CarToBeReturned: FunctionComponent<Props> = ({ t }) => {
  return (
    <FormField
      required
      type="select"
      name="carToBeReturned"
      labelText={t('step2:heading:carToBeReturned')}
      render={(fieldProps) => (
        <SelectBR {...fieldProps}>
          {yesOrNot?.map(({ label, value }) => (
            <SelectBR.Item key={`${label}`} value={`${value}`}>
              {label}
            </SelectBR.Item>
          ))}
        </SelectBR>
      )}
    />
  );
};

export const MaritalStatus: FunctionComponent<Props> = ({ t, cocontractor }) => {
  return (
    <FormField
      required
      type="select"
      name={cocontractor ? 'maritalStatusCoContractor' : 'maritalStatus'}
      labelText={t('step4:maritalStatus:label')}
      render={(fieldProps) => (
        <SelectBR {...fieldProps}>
          {maritalStatusOptions?.map(({ label, value }) => (
            <SelectBR.Item key={`${label}`} value={`${value}`}>
              {label}
            </SelectBR.Item>
          ))}
        </SelectBR>
      )}
    />
  );
};

export const NumberOfDependentChildren: FunctionComponent<Props> = ({ cocontractor }) => (
  <NumericFormField
    fieldName={cocontractor ? 'numberOfDependentChildrenCoContractor' : 'numberOfDependentChildren'}
    type="numeric"
    labelTranslationKey="step4:numberOfDependentChildren:label"
    maximumFractionDigits={0}
    allowEmpty
  />
);

export const ResidenceStatus: FunctionComponent<Props> = ({ t, name = 'residenceStatus' }) => {
  return (
    <FormField
      required
      type="select"
      name={name}
      labelText={t('step4:residenceStatus:label')}
      render={(fieldProps) => (
        <SelectBR {...fieldProps}>
          {housingSituationOptions?.map(({ label, value }) => (
            <SelectBR.Item key={`${label}`} value={`${value}`}>
              {label}
            </SelectBR.Item>
          ))}
        </SelectBR>
      )}
    />
  );
};

export const MonthlyRent: FunctionComponent<Props> = ({ cocontractor }) => (
  <NumericFormField
    fieldName={cocontractor ? 'monthlyRentCoContractor' : 'monthlyRent'}
    type="numeric"
    labelTranslationKey="step4:monthlyRent:label"
    maximumFractionDigits={2}
  />
);

export const OtherMonthlyCosts: FunctionComponent<Props> = ({ cocontractor }) => (
  <NumericFormField
    fieldName={cocontractor ? 'otherMonthlyCostsCoContractor' : 'otherMonthlyCosts'}
    type="numeric"
    labelTranslationKey="step4:otherMonthlyCosts:label"
    infoTextTranslationKey="step4:otherMonthlyCosts:infoText"
    maximumFractionDigits={2}
  />
);

export const ContractType: FunctionComponent<Props> = ({ t, cocontractor, disabled }) => {
  return (
    <FormField
      required
      type="select"
      name={cocontractor ? 'contractTypeCoContractor' : 'contractType'}
      labelText={t('step4:contractType:label')}
      render={(fieldProps) => (
        <SelectBR {...fieldProps} disabled={disabled}>
          {contractTypeOptions?.map(({ label, value }) => (
            <SelectBR.Item key={`${value}`} value={`${value}`}>
              {label}
            </SelectBR.Item>
          ))}
        </SelectBR>
      )}
    />
  );
};

export const ContractTypeSCT: FunctionComponent<Props> = ({ cocontractor }) => {
  return (
    <TextFormField
      fieldName={cocontractor ? 'contractTypeCoContractorSCT' : 'contractTypeSCT'}
      labelTranslationKey="step4:contractType:label"
      isReadonly
    />
  );
};

export const EmploymentStartDate: FunctionComponent<Props> = ({
  label,
  values,
  setFieldValue,
  cocontractor,
  infoText,
}) => {
  const fieldName = cocontractor ? 'employmentStartDateCoContractor' : 'employmentStartDate';
  const { setFieldValue: setFieldValueInternal } = useFormikContext<any>();
  return (
    <FormField
      name={fieldName}
      type="other"
      labelText={label}
      required
      infoText={infoText}
      render={(fieldProps) => (
        <DatePicker
          {...fieldProps}
          name={fieldName}
          maxDate={moment().toDate()}
          dateFormat="d/m/Y"
          locale="fr"
          placeholder="d/m/Y"
          mode="single"
          flatpickrOptions={{
            onClose: (e: any) => {
              const date = normalizeDate(e);
              try {
                if (date === 'Invalid date') {
                  throw new Error('');
                }
                setFieldValue(fieldName, normalizeDate(e));
                setFieldValueInternal(fieldName, normalizeDate(e));
              } catch (error) {
                setFieldValue('');
                setFieldValueInternal(fieldName, '');
              }
            },
          }}
          value={get(values, fieldName, '')}
          onChange={(e) => {
            setFieldValue(fieldName, e);
            setFieldValueInternal(fieldName, e);
          }}
          onBlur={(e) => {
            setFieldValue(fieldName, e);
            setFieldValueInternal(fieldName, normalizeDate(e));
          }}
        />
      )}
    />
  );
};

export const Employer: FunctionComponent<Props> = ({ cocontractor }) => (
  <TextFormField
    fieldName={cocontractor ? 'employerCoContractor' : 'employer'}
    labelTranslationKey="step4:employer:label"
  />
);

export const CountryCodeEmployer: FunctionComponent<Props> = ({ t, cocontractor }) => (
  <FormField
    name={cocontractor ? 'countryCodeEmployerCoContractor' : 'countryCodeEmployer'}
    type="input"
    labelText={t('step4:countryCodeEmployer:label')}
    required
    render={(fieldProps) => (
      <SelectBR {...fieldProps}>
        {countryCodesOptions?.map(({ label, id, value }) => (
          <SelectBR.Item key={`${id}-${fieldProps.name}`} value={value}>
            {label}
          </SelectBR.Item>
        ))}
      </SelectBR>
    )}
  />
);

export const ZipCodeEmployer: FunctionComponent<Props> = ({ cocontractor }) => {
  const fieldName = cocontractor ? 'zipCodeEmployerCoContractor' : 'zipCodeEmployer';

  return (
    <MaskedTextFormField
      fieldName={fieldName}
      labelTranslationKey="step4:zipCodeEmployer:label"
      mask={masks.zipCodeMask}
    />
  );
};

export const CityEmployer: FunctionComponent<Props> = ({ cocontractor }) => {
  const { setFieldValue } = useFormikContext<any>();
  const fieldName = cocontractor ? 'cityEmployerCoContractor' : 'cityEmployer';

  return (
    <MaskedTextFormField
      mask={masks.cityEmployerMask}
      fieldName={fieldName}
      labelTranslationKey="step4:cityEmployer:label"
      overwrite
      onAccept={(transformedValue) => {
        const newTransformedValue = formatCityNameWithProperCasing(transformedValue);
        setFieldValue(fieldName, newTransformedValue);
      }}
      allowAccents
    />
  );
};

export const BirthCountry: FunctionComponent<Props> = ({ name, cocontractor, setFieldValue, disabled }) => {
  const { setFieldValue: setFieldValueInternal } = useFormikContext<any>();
  return (
    <SelectFormField
      fieldName={name}
      labelTranslationKey="step4:birthCountry:label"
      dropDownOptionsList={countryCodesOptions}
      isDisabled={disabled}
      onChange={(selectedValue) => {
        const birthCountry = selectedValue.target.value;
        const postalCodeOfBirthCountry = countryCodesOptions.find(
          (country) => country.value === birthCountry
        )?.postalCode;
        const zipCodeOfBirthField = cocontractor ? 'zipCodeOfBirthCocontractor' : 'zipCodeOfBirth';
        setFieldValue(name, birthCountry);
        setFieldValueInternal(zipCodeOfBirthField, postalCodeOfBirthCountry);
      }}
    />
  );
};

export const Nationality: FunctionComponent<Props> = ({ name, disabled }) => {
  return (
    <SelectFormField
      fieldName={name}
      labelTranslationKey="step4:nationality:label"
      dropDownOptionsList={countryCodesOptions}
      isDisabled={disabled}
    />
  );
};

export const ZipCodeOfBirth: FunctionComponent<
  Props & {
    suggestions?: CitiesAndZipCodesSuggestion[];
    onSelectSuggestion?: (suggestion: string) => void;
    onChange?: (text: string) => void;
  }
> = ({ name, values, cocontractor, disabled, onChange, isSectionLoading, suggestions, onSelectSuggestion }) => {
  const { t } = useTranslation();
  const isBirthCountryFrench = cocontractor
    ? values.birthCountryCocontractor === 'France' || values.birthCountryCocontractor === 'FR'
    : values.birthCountry === EnumCountryCode.FRANCE || values.birthCountry === 'FR';
  const isFrenchTerritory = frenchTerritoriesOptions.some((option) => option.value === values.birthCountry);
  return (
    <FormField
      name={name}
      disabled={!isFrenchTerritory || disabled}
      type="text"
      labelText={t('step4:zipCodeOfBirth:label')}
      required={isBirthCountryFrench}
      render={() => (
        <InputAutosuggest
          value={values.zipCodeOfBirth}
          name={name}
          list={suggestions?.map(({ city, zipCode }) => `${zipCode} ${city}`)}
          disabled={!isFrenchTerritory || disabled}
          openOnFocus
          addonSpinner={isSectionLoading ? <Spinner /> : null}
          awesompleteProps={{
            filter: () => true,
            maxItems: 20,
          }}
          onChange={(e) => {
            onChange?.(e.target.value.replace(/\D+/g, ''));
          }}
          onSelect={(e: any) => {
            onSelectSuggestion?.(e.text?.value);
          }}
        />
      )}
    />
  );
};

export const PlaceOfBirth: FunctionComponent<
  Props & {
    suggestions?: CitiesAndZipCodesSuggestion[];
    onSelectSuggestion?: (suggestion: string) => void;
    onChange?: (text: string) => void;
  }
> = ({ name, values, cocontractor, disabled, suggestions, isSectionLoading, onChange, onSelectSuggestion }) => {
  const { t } = useTranslation();

  return (
    <FormField
      name={name}
      type="text"
      labelText={t('step4:placeOfBirth:label')}
      disabled={disabled}
      required={
        cocontractor
          ? values?.birthCountryCocontractor === EnumCountryCode.FRANCE || values.birthCountryCocontractor === 'FR'
          : values?.birthCountry === EnumCountryCode.FRANCE || values.birthCountry === 'FR'
      }
      render={() => (
        <InputAutosuggest
          name={name}
          value={values.placeOfBirth}
          list={suggestions?.map(({ city, zipCode }) => `${city} ${zipCode}`)}
          awesompleteProps={{
            filter: () => true,
            maxItems: 20,
          }}
          addonSpinner={isSectionLoading ? <Spinner /> : null}
          disabled={disabled}
          openOnFocus
          onChange={(e) => {
            const newTransformedValue = formatCityNameLettersAndSpaceOnly(e.target.value);
            onChange?.(newTransformedValue || '');
          }}
          onSelect={(e: any) => {
            onSelectSuggestion?.(e.text.value);
          }}
        />
      )}
    />
  );
};

export const NetIncomeAmount: FunctionComponent<Props> = ({ cocontractor }) => (
  <NumericFormField
    fieldName={cocontractor ? 'netIncomeAmountCoContractor' : 'netIncomeAmount'}
    type="numeric"
    labelTranslationKey="step4:netIncomeAmount:label"
    maximumFractionDigits={2}
  />
);

export const AdditionalIncomeAmount: FunctionComponent<Props> = ({ cocontractor }) => (
  <NumericFormField
    fieldName={cocontractor ? 'additionalIncomeAmountCoContractor' : 'additionalIncomeAmount'}
    type="numeric"
    labelTranslationKey="step4:additionalIncomeAmount:label"
    maximumFractionDigits={2}
  />
);

export const CocontractorCheckbox: FunctionComponent<Props & { readonly?: boolean }> = ({
  t,
  setFieldValue,
  cocontractor,
  readonly,
  disabled,
}) => (
  <FormField
    name="cocontractor"
    type="checkbox"
    labelText=""
    required
    render={(fieldProps) => (
      <Checkbox
        {...fieldProps}
        onChange={(e) => {
          setFieldValue('cocontractor', e.target.checked);
        }}
        checked={cocontractor}
        disabled={disabled}
        readOnly={readonly}
      >
        {t('step2:cocontractor:label')}
      </Checkbox>
    )}
  />
);

export const IsCustomerHasCompany: FunctionComponent<Props> = ({ t, setFieldValue }) => {
  const name = 'oneCustomerHasCompany';

  return (
    <FormField
      type="select"
      name={name}
      labelText={t('step4:customerHasCompany:label')}
      required
      render={(fieldProps) => (
        <SelectBR
          {...fieldProps}
          onChange={(e) => {
            setFieldValue('oneCustomerHasCompany', e.target.value);
          }}
        >
          {yesOrNot?.map(({ label, value }) => (
            <SelectBR.Item key={`${label}`} value={`${value}`}>
              {label}
            </SelectBR.Item>
          ))}
        </SelectBR>
      )}
    />
  );
};

export const SIRENWebserviceCall: FunctionComponent<Props> = ({ index }) => {
  const fieldName = `sirenWebserviceCall_${index}`;

  return (
    <MaskedTextFormField
      fieldName={fieldName}
      labelTranslationKey="step4:companySirenNumber:label"
      mask={masks.sirenMask}
    />
  );
};

export const KindOfCompany: FunctionComponent<Props> = ({ t, index, setFieldValue }) => {
  const name = `oneCustomerHasCompany_${index}`;

  useEffect(() => {
    setFieldValue(name, '');
  }, [name, setFieldValue]);

  return (
    <FormField
      required
      type="select"
      name={name}
      labelText={t('step4:customerHasCompany:kindOfCompany:label')}
      render={(fieldProps) => (
        <SelectBR {...fieldProps}>
          {kindOfCompany?.map(({ label, value }) => (
            <SelectBR.Item key={`${label}`} value={`${value}`}>
              {label}
            </SelectBR.Item>
          ))}
        </SelectBR>
      )}
    />
  );
};

export const SIRENFields: FunctionComponent<Props> = ({ t, index, setFieldValue }) => (
  <>
    <Layout.Item default="1/2" s="1/1">
      <KindOfCompany t={t} index={index} setFieldValue={setFieldValue} />
    </Layout.Item>
    <Layout.Item default="1/2" s="1/1">
      <SIRENWebserviceCall t={t} index={index} setFieldValue={setFieldValue} />
    </Layout.Item>
  </>
);

const getIndicesArray = (neededIndices: number) => {
  return new Array(neededIndices).fill('').map((_, i) => i);
};

export const CustomerInCompanyFields: FunctionComponent<
  Props & { setFieldValue: (field: string, value: any) => void }
> = ({ t, setFieldValue }) => {
  const { values, setValues } = useFormikContext<InvolvementInCompanies>();
  const [indicesArray, setIndicesArray] = useState<number[]>([]);
  const companyFieldsMaxNumber = 3;

  const hasCompany = values.oneCustomerHasCompany === BooleanEnum.true;

  useEffect(() => {
    if (!hasCompany) {
      setIndicesArray([]);
    } else if (indicesArray.length === 0) {
      setIndicesArray([0]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasCompany]);

  useEffect(() => {
    const neededIndices = Object.keys(values).filter((k) => k.startsWith('sirenWebserviceCall_')).length;
    if (neededIndices === indicesArray.length) return;
    if (!hasCompany) return;

    setIndicesArray(getIndicesArray(neededIndices));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values]);

  useEffect(() => {
    const newValues = indicesArray.reduce(
      (acc, index) => {
        return {
          ...acc,
          [`oneCustomerHasCompany_${index}`]: values[`oneCustomerHasCompany_${index}`],
          [`sirenWebserviceCall_${index}`]: values[`sirenWebserviceCall_${index}`],
        };
      },
      {} as Omit<InvolvementInCompanies, 'oneCustomerHasCompany'>
    );

    setValues({
      oneCustomerHasCompany: values.oneCustomerHasCompany,
      ...(values.oneCustomerHasCompany ? newValues : {}),
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [indicesArray]);

  if (!hasCompany) return null;

  return (
    <>
      {indicesArray?.map((item) => <SIRENFields key={item} t={t} index={item} setFieldValue={setFieldValue} />)}
      <Layout.Item default="1/12" m="1/6">
        <Button
          type="button"
          icon="semantic-zoom-in"
          ariaLabel="add new siren field"
          round
          disabled={indicesArray.length >= companyFieldsMaxNumber}
          onClick={() => {
            setIndicesArray(getIndicesArray(indicesArray.length + 1));
          }}
        />
      </Layout.Item>
      <Layout.Item default="1/12" m="1/6">
        {indicesArray.length > 0 && (
          <Button
            type="button"
            icon="semantic-zoom-out"
            ariaLabel="remove siren field"
            round
            onClick={() => {
              setIndicesArray((oldArray) => oldArray.slice(0, -1));
              const currentIndicesCount = indicesArray.length;
              if (currentIndicesCount === 1) {
                setFieldValue('oneCustomerHasCompany', BooleanEnum.false);
              }
            }}
          />
        )}
      </Layout.Item>
    </>
  );
};
